<template>
    <TVJoyDialog class="phone-number-dialog">
        <template #dialog-header>{{ $t('projectclient.quote.view.quote-summary.dialog.phone-number.title') }}</template>

        <template #dialog-body>
            <VJoyWrapper row-gap="2" justify="flex-start">
                <p class="phone-number-dialog__paragraph">{{ $t('projectclient.quote.view.quote-summary.dialog.phone-number.explanation.title') }}</p>
                <div class="phone-number-dialog__paragraph">
                    <VJoyIcon name="check-circle" color="neutral-50" />
                    <p>{{ $t('projectclient.quote.view.quote-summary.dialog.phone-number.explanation.security') }}</p>
                </div>
                <div class="phone-number-dialog__paragraph">
                    <VJoyIcon name="check-circle" color="neutral-50" />
                    <p>{{ $t('projectclient.quote.view.quote-summary.dialog.phone-number.explanation.support') }}</p>
                </div>
            </VJoyWrapper>

            <PhoneNumber v-model="phoneNumber" :lazy-validation="true" />
            <span class="phone-number-dialog__third-party-info">
                {{ $t('projectclient.quote.view.quote-summary.dialog.phone-number.third-party-info') }}
            </span>
        </template>

        <template #dialog-confirm>
            <VJoyButton variant="main" :loading="loading" :disabled="loading || !phoneNumber" @click="handleConfirm">
                {{ $t('general.confirm') }}
            </VJoyButton>
        </template>
    </TVJoyDialog>
</template>

<script setup lang="ts">
    import {computed, ref} from 'vue';
    import {PhoneNumber} from '#components';
    import {storeToRefs, useAuth, useTranslation} from '#imports';
    import {VJoyButton, VJoyWrapper, VJoyIcon, pushVJoySnackbar} from '@maltjoy/core-vue';
    import {useDialogRoot} from '~/common/composables';
    import {useClientQuoteViewStore} from '~/features/quote/stores';

    const {TVJoyDialog, confirmDialog} = useDialogRoot();
    const clientQuoteStore = useClientQuoteViewStore();
    const {t} = useTranslation();
    const authStore = useAuth();

    const {user} = storeToRefs(authStore);

    const loading = ref(false);
    const phoneNumber = ref('');

    const userAccountId = computed(() => authStore.user?.id);

    async function handleConfirm() {
        loading.value = true;

        try {
            await clientQuoteStore.setAccountPhoneNumber(userAccountId.value!, phoneNumber.value);
            confirmDialog();
        } catch (e) {
            pushVJoySnackbar({
                props: {message: t('projectclient.quote.view.quote-summary.dialog.phone-number.error'), level: 'error'},
            });
        }

        loading.value = false;
    }
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .phone-number-dialog {
        p {
            @include text.getFontBySize(primary-400);

            margin-bottom: 0;
        }

        &__paragraph {
            display: flex;
            align-items: center;
            gap: var(--joy-core-spacing-2);
        }

        &__third-party-info {
            @include text.getFontBySize(primary-200);

            color: var(--joy-color-neutral-40);
        }
    }
</style>
